
import {BrowserRouter as  Routes, Route} from 'react-router-dom'
import HeaderOne from "../header/HeaderOne"
import * as React from 'react'
import FooterOne from '../footer/FooterOne'
import Breadcrumb from '../components/BreadCurmb'
import AboutSection from '../components/AboutSection'
import WorkProcess from '../components/WorkPorcess'
import OfficeTour from '../components/OfficeTour'
import BrandSlider from '../components/BrandSlider'
import Head from '../components/Head'
export default function About() {
  return (
<>
    <Head
      title="About — Android SMS Gateway Built for Solo Founders"
      description="TextLink is an SMS gateway that turns spare Android phones into senders. Built solo from the ground up for agencies, SaaS founders, and trucking dispatchers tired of Twilio fees and 10DLC paperwork."
      canonical="/about"
    />
    <HeaderOne />
    <Breadcrumb title="About Company" subtitle="Responsive & functional IT design" pagetitle="About"/>
    <AboutSection/>
    <WorkProcess/>
    <OfficeTour/>
    <BrandSlider/>
    <FooterOne/>      
</>
  )
}
